import { render, staticRenderFns } from "./dashboardfleetClean.vue?vue&type=template&id=4498191c&scoped=true"
import script from "./dashboardfleetClean.vue?vue&type=script&lang=js"
export * from "./dashboardfleetClean.vue?vue&type=script&lang=js"
import style0 from "./dashboardfleetClean.vue?vue&type=style&index=0&id=4498191c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498191c",
  null
  
)

export default component.exports